export const init = () => {
    const initializeGalleries = () => {
        const galleries = document.querySelectorAll('.s-multi-gallery');
        if (!galleries.length) return;
        const isDesktop = window.innerWidth >= 1056;

        galleries.forEach((item) => {
            const sections = item.querySelectorAll('section[id]');
            
            const handleScroll = () => {
                const scrollY = window.scrollY;
                const bodyRect = document.body.getBoundingClientRect();

                sections.forEach(current => {
                    const sectionTop = current.getBoundingClientRect().top - 140 - bodyRect.top;
                    const sectionBottom = sectionTop + current.offsetHeight;
                    const sectionId = current.getAttribute("id");
                    const linkElement = document.querySelector(`.s-multi-gallery__sidebar a[href*="${sectionId}"]`);
                    if (!linkElement) return;
                    if (scrollY > sectionTop && scrollY <= sectionBottom) {
                        linkElement.parentElement.classList.add("active");
                       
                    } else {
                        linkElement.parentElement.classList.remove("active");
                    }
                });
            };

            const debouncedScroll = debounce(handleScroll, 100);

            if (isDesktop) {
                window.addEventListener("scroll", debouncedScroll);
            } else {
                const select = item.querySelector('.g-input__select-box');
                if (select) {
                    select.addEventListener('change', (e) => {
                        e.preventDefault();
                        window.location.hash = `#${select.value}`;
                    });
                }
            }
        });
    };

    // Původní inicializace pro prvotní načtení stránky
    initializeGalleries();

    // Nastavení MutationObserver pro detekci přidání .s-multi-gallery do DOM
    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.matches('.s-multi-gallery')) {
                    initializeGalleries();
                }
            });
        });
    });

    // Pozorujeme celý dokument nebo specifický kontejner
    observer.observe(document.body, { childList: true, subtree: true });
};

// Debounce function to limit the rate of function execution
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}